import { heroEquipment } from "../HeroEquipment";

export const arabia = {
  heroes: {
    Emir: {
      id: 0,
      startingEquipment: ["Sztylet", "Chopesz"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Kupiecka karawana z Arabii"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Dowódca", "Przepastne trzewia", "Żyłka handlowa"],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    Wezyr: {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Nieumarły sabat rodu Nekrarch"]["Nekrarcha"],
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Mag(Tradycja Metalu albo Magia Żywiołów)",
        "Przepastne trzewia",
        "Żyłka handlowa",
      ],
      exp: 12,
      skills: [0, 2, 4, 5],
    },
    "Handlarz niewolników": {
      id: 2,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 2,
      equipmentList: heroEquipment["Kupiecka karawana z Arabii"].Bohaterowie,
      type: "Bohater",
      stats: {
        "Początkowa": [4,3,3,3,3,1,3,1,7],
        "Maksymalna": [5,6,6,4,4,3,6,4,9]
      },
      rules: ["Handlarz niewolników", "Żyłka handlowa"],
      exp: 8,
      skills: [0, 3, 5],
    },
    Wieszcz: {
      id: 3,
      startingEquipment: ["Sztylet"],
      cost: 15,
      number: 1,
      equipmentList: heroEquipment["Kupiecka karawana z Arabii"].Bohaterowie,
      type: "Bohater",
      stats: {
        "Początkowa": [4,2,2,3,3,1,3,1,6],
        "Maksymalna": [5,6,6,4,4,3,6,4,9]
      },
      rules: ["Szczęście", "Tarot", "Wzgardzony", "Żyłka handlowa"],
      exp: 0,
      skills: [0, 2, 4, 5],
    },
    Niewolnik: {
      id: 4,
      startingEquipment: ["Broń improwizowana"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 2],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mięso armatnie", "Niewolnik", "Rozmiar rzondzi"],
    },
    Strażnik: {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 15,
      equipmentList: heroEquipment["Kupiecka karawana z Arabii"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Drużyna obsługi"],
    },
    Dżinn: {
      id: 6,
      startingEquipment: ["Broń naturalna (przebicie pancerza)"],
      cost: 45,
      number: 3,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 4, 0, 4, 3, 1, 4, 2, 6],
        Maksymalna: [4, 4, 0, 4, 3, 1, 4, 2, 6],
      },
      rules: ["Demon", "Genius", "Istota magiczna (Tradycja Niebios)", "Lot"],
    },
    Nomada: {
      id: 7,
      startingEquipment: ["Sztylet","Chopesz","Łuk krótki","Koń bojowy","Siodło & uprząż"],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Kupiecka karawana z Arabii"].Nomada,
      type: "Stronnik",
      stats: {
        "Początkowa": [4,3,4,3,3,1,3,1,7],
        "Maksymalna": [5,6,6,4,4,3,6,4,9],
        "Koń bojowy": [8,3,0,3,"-","-",3,1,5]
      },
      rules: ["Kawalerzysta", "Lekka jazda", "Ranger", "Zwiadowca"],
    },
    Derwisz: {
      id: 8,
      startingEquipment: ["Chopesz"],
      cost: 40,
      number: 5,
      equipmentList: heroEquipment["Kupiecka karawana z Arabii"].Derwisz,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 4, 4, 1, 3, 1, 10],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Fanatyk", "Furia"],
    },
    Ifryt: {
      id: 9,
      startingEquipment: ["Broń naturalna (płonący atak)"],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 4, 0, 5, 4, 3, 4, 3, 6],
        Maksymalna: [6, 4, 0, 5, 4, 3, 4, 3, 6],
      },
      rules: ["Bycza szarża","Demon","Duży cel","Genius","Głód krwi","Nienawiść","Odwieczny konflikt","Ognista korona","Przepastne trzewia","Wielkolud"],
    },
    Więźniarka: {
      id: 10,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Powóz", "Więźniarka"],
    },
    "Latający dywan": {
      id: 11,
      startingEquipment: [],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Początkowa: [6, 3, 0, 4, 5, 3, 6, 2, 6],
        Maksymalna: [6, 3, 0, 4, 5, 3, 6, 2, 6],
      },
      rules: [
        "Bombardowanie (zatruty atak)",
        "Demon",
        "Lot",
        "Potwór",
        "Wierzchowiec",
        "Latający dywan",
      ],
    },
  },
  limit: 600,
  minModels: 3,
  maxModels: 15,
  name: "Kupiecka karawana z Arabii",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (2)", "Podatek", "Rozrzutność", "Zamożność"],
  mercenaries: [
    "Balistyk",
    "Bombardier",
    "Czarownica",
    "Gladiator",
    "Goniec",
    "Kartograf",
    "Kupiec",
    "Łowca nagród",
    "Magus",
    "Medyk",
    "Minstrel",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Ordynans",
    "Pogromca Trolli",
    "Poszukiwacz złota",
    "Rozbójnik",
    "Rycerz najemny",
    "Skryba",
    "Strażnik dróg",
    "Szpieg",
    "Tileański kusznik",
    "Woźnica",
    "Zwadźca",
    "Zwiadowca",
  ],
};
